import { styled } from "@vitality-ds/system";
import BaseTextareaStyles from "./styles/BaseTextarea.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseTextarea = styled("textarea", BaseTextareaStyles);